module.exports = __webpack_public_path__ + "media/images/mail-instagram-b608d44222b6d86c2320391b93f29bdb.png";